import React from 'react';
import { motion } from 'framer-motion';
import { 



  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope
} from 'react-icons/fa';

import { FiHome, FiDollarSign, FiTruck, FiFileText, FiTool, FiCalendar, FiPackage } from 'react-icons/fi';
import { GiPianoKeys, GiWoodCabin, GiHomeGarage, GiScrew } from 'react-icons/gi';
import { LuBug } from "react-icons/lu";
import { FiSettings } from "react-icons/fi";
import { FaCogs } from "react-icons/fa";
import { GiWoodBeam } from "react-icons/gi";
import { GiWoodFrame } from "react-icons/gi";
import { MdOutlineContactSupport } from "react-icons/md";
import { GiGrandPiano } from "react-icons/gi";

import '../../assets/css/footer.css';

const Footer = () => {
  const siteMapLinks = [
    { icon: <FiHome className="site-map-icon" />, text: 'Home', url: '/' },
    { icon: < GiGrandPiano className="site-map-icon"  />, text: 'Pianos à Venda', url: '/pianos' },
    { icon: <GiWoodBeam className="site-map-icon"  />, text: 'Restauração do Móvel', url: '/restauracao-movel' },
    { icon: <LuBug className="site-map-icon" />, text: 'Descupinização', url: '/descupinizacao' },
       { icon: <GiScrew className="site-map-icon" />, text: 'Conserto de Cravelhas', url: '/conserto-cravelhas' },
          { icon: <FiSettings className="site-map-icon" />, text: 'Regulagem', url: '/regulagem' },
           { icon: <FaCogs className="site-map-icon"  />, text: 'Reforma do Mecanismo', url: '/reforma-mecanismo' },
            { icon: <GiPianoKeys className="site-map-icon" />, text: 'Restauração do Teclado', url: '/restauracao-teclado' },
             { icon: <GiWoodFrame className="site-map-icon" />, text: 'Serviço de Marcenaria', url: '/marcenaria' },
             { icon: <FiTruck className="site-map-icon" />, text: 'Transporte', url: '/transporte' },
             { icon: <FiPackage className="site-map-icon" />, text: 'Armazenagem', url: '/armazenagem' },
             { icon: <FiCalendar className="site-map-icon" />, text: 'Aluguel', url: '/aluguel' },
             { icon: <FiFileText className="site-map-icon" />, text: 'Consignação', url: '/consignacao' },
               { icon: <FiDollarSign className="site-map-icon" />, text: 'Compramos seu Piano', url: '/compra' },
               { icon: < MdOutlineContactSupport className="site-map-icon" />, text: 'Politica de Vendas', url: '/politica-de-vendas' },
               { icon: < MdOutlineContactSupport className="site-map-icon" />, text: 'Contato', url: '/orcamento' }
  ];



  const partnerLogos = [
    '/img/logotipos/fritz.webp', 
    '/img/logotipos/brasil.webp', 
    '/img/logotipos/bechstein.webp',
    '/img/logotipos/essenfelder.webp', 
    '/img/logotipos/yamaha.webp',
    '/img/logotipos/fritz.webp',
    '/img/logotipos/brasil.webp'
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Seção do Logo */}
        <motion.div 
          className="footer-logo animated-item"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <img src="/img/logo_waldir_footer.webp" alt="Waldir Pianos" className="logo-img" />
        </motion.div>

        {/* Mapa do Site */}
        <motion.div 
          className="site-map animated-item delay-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <h3 className="site-map-title">Navegação</h3>
          <div className="site-map-column">
            {siteMapLinks.slice(0, 8).map((link, index) => (
              <a key={index} href={link.url} className="site-map-link">
                {link.icon} {link.text}
              </a>
            ))}
          </div>
          <div className="site-map-column">
            {siteMapLinks.slice(8).map((link, index) => (
              <a key={index} href={link.url} className="site-map-link">
                {link.icon} {link.text}
              </a>
            ))}
          </div>
        </motion.div>

        {/* Informações de Contato */}
        <motion.div 
          className="footer-contact animated-item delay-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <h3 className="contact-title">Contato</h3>
          <div className="contact-info">
            <FaMapMarkerAlt className="contact-icon" />
            <div className="contact-text">
              Rua Waldemar Martins, 695<br />
              Casa Verde - CEP: 02535-001<br />
              São Paulo/SP
            </div>
          </div>
          <div className="contact-info">
            <FaPhone className="contact-icon" />
            <div className="contact-text">11 2256-5987</div>
          </div>
          <div className="contact-info">
            <FaEnvelope className="contact-icon" />
            <div className="contact-text">comercial@pianoswaldir.com.br</div>
          </div>
        </motion.div>
      </div>

      {/* Seção Inferior do Footer */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          {/* Logo à esquerda */}
          <motion.div 
            className="footer-brand animated-item"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <img src="/img/selo.webp" alt="Solução Anti Cupim" className="brand-logo" />
          </motion.div>

          {/* Carrossel de logos no meio */}
          <motion.div 
            className="logos-carousel animated-item delay-1"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="logos-track">
              {partnerLogos.map((logo, index) => (
                <div key={index} className="logo-item">
                  <img src={logo} alt={`Parceiro ${index + 1}`} />
                </div>
              ))}
            </div>
          </motion.div>

          {/* Logo à direita */}
          <motion.div 
            className="footer-brand animated-item delay-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <img src="/img/logo_google.webp" alt="Transporte Especializado" className="brand-logo" />
          </motion.div>
        </div>
      </div>

      {/* Direitos autorais */}
      <motion.div 
        className="footer-copyright animated-item delay-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        &copy; {new Date().getFullYear()} Waldir Pianos - Todos os direitos reservados
          <img className='cts-img' src='img/cts.webp' />
      </motion.div>
    
    </footer>
  );
};

export default Footer;